import React, { ReactNode } from 'react';

const FixedBottom = ({ children }: { children: ReactNode }) => {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        maxWidth: '900px',
      }}
    >
      {children}
    </div>
  );
};

export default FixedBottom;
